export default __webpack_public_path__ + "static/media/SacredObligation.d66efbcb.png";